import { TableCell, TableRow, Typography } from "@mui/material"

export function NoEstateResults({ columns = 1, message = "Nothing matches that search." }) {
    return (
        <TableRow>
            <TableCell colSpan={columns}>
                <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>
                    {message}
                </Typography>
            </TableCell>
        </TableRow>
    )
}
